export default {
    rootViewStyle: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, .6)',
        color: '#fff',
        textAlign: 'center'
    },
    arrowPicEleStyle: {
        position: 'absolute',
        top: '4.4vw',
        right: '6.13vw',
        width: '23.2vw',
        height: '28.93vw'
    },
    guidePicEleStyle: {
        position: 'absolute',
        top: '35.2vw',
        left: '0',
        right: '0',
        width: '81.6vw',
        height: '26.7vw',
        margin: '0 auto'
    },
};
